module.exports = "<div #mainWrp [class]=\"cssClass\" [class.d-none]=\"!show\" style=\"width: 100%; height: 100%; overflow: auto\">\r\n    <div *ngIf=\"text\" [class]=\"class\" class=\"loading-text\">{{ text | translate }}</div>\r\n    <img #img src=\"/assets/img/loading.gif\" alt=\"Loading...\" (blur)=\"setFocusToImg()\" tabindex=\"-1\"/>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/wait-image.component/wait-image.component.html
// module id = ./src/app/shared/components/wait-image.component/wait-image.component.html
// module chunks = main